import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import Actions from '../../actions';
import APP_ACTIONS from '../../constants/app-actions';
import AddressForm from '../../components/checkout-steps/address-form';
import CountryAPI from '../../apis/country';

import APP_ROUTES from '../../constants/app-routes';

const mapStateToProps = (state, ownProps) => ({
    order: state.order,
    currentZone: state.zones.currentZone,
    currentStore: state.stores.currentStore,
    displayLoader: state.displayLoader,
    billingCountries: state.countryList.shippingCountries,
    shippingCountries: state.countryList.billingCountries,
    placedOrder: state.placedOrder,
    locale: state.locale,
    hasExtraTimeCheckout: state.cartState.hasExtraTimeCheckout,
    gracePeriod: state.cartState.gracePeriod,
    fetchData: state.fetchData,
});

const mapDispatchToProps = (dispatch) => ({
    setCurrentCheckoutStep: () => {
        dispatch({
            type: APP_ACTIONS.SET_CURRENT_CHECKOUT_STEP,
            payload: 'address',
        });
    },

    handleAddressFormSubmit: (formData, order, locale) => dispatch(Actions.goToNextStep(order, locale, formData)),

    handleCheckoutStepNotEditable: (order, placedOrder) => {
        /* Redirect to last step if order is already placed */
        if (placedOrder.id) {
            dispatch(push(APP_ROUTES.checkout[`${placedOrder.checkout_steps.slice(-1)}PageRoute`]));
        }
    },

    redirectToCart: () => dispatch(push(APP_ROUTES.cartPageRoute)),
});

const AddressFormConnector = connect(mapStateToProps, mapDispatchToProps)(AddressForm);

export default AddressFormConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/checkout-steps/address-form-connector.js
 **/